/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { Fragment, useState } from 'react';

import { useIntl } from 'react-intl-next';

import { IconButton } from '@atlaskit/button/new';
import { cssMap, cx, jsx } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/core/cross';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	container: {
		borderRadius: token('radius.small'),
		border: `${token('border.width')} solid ${token('color.border')}`,
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
	},
});

export const ErrorCard = ({ query }: { query: string }) => {
	const { formatMessage } = useIntl();
	const [isOpen, setIsOpen] = useState(true);

	return (
		<Fragment>
			{isOpen ? (
				<Inline xcss={cx(styles.container)} spread="space-between" alignBlock="center">
					<Text weight="bold">{formatMessage(messages.errorMessage, { title: query })}</Text>
					<IconButton
						appearance="subtle"
						icon={CrossIcon}
						label={formatMessage(messages.close)}
						onClick={() => setIsOpen(false)}
					/>
				</Inline>
			) : null}
		</Fragment>
	);
};
